import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

const PageHeaderSlotContext = createContext<ReactNode>(null);

type PageHeaderSlotProviderProps = {
  readonly slot: ReactNode;
  readonly children: ReactNode;
};

function PageHeaderSlotProvider({ slot, children }: PageHeaderSlotProviderProps) {
  return <PageHeaderSlotContext.Provider value={slot}>{children}</PageHeaderSlotContext.Provider>;
}

function usePageHeaderSlot(): ReactNode {
  return useContext(PageHeaderSlotContext);
}

export { PageHeaderSlotProvider, usePageHeaderSlot };
